import React from 'react';
import { useLocation } from 'react-router-dom';
import Icon from '../Icon';
import { useRecordNav } from '../../hooks/useRecordNav';
import { parseEntityPath } from '../../utils/entityRoutes';
import type { EntityKind } from '../../utils/entityRoutes';

interface RecordNavButtonsProps {
  kind: EntityKind;
  currentId: string | number;
}

/** Previous / next arrows for one record: the same row order as the list the user came from. */
export const RecordNavButtons: React.FC<RecordNavButtonsProps> = ({ kind, currentId }) => {
  const nav = useRecordNav(kind, currentId);
  if (!nav.available) return null;
  const noun = nav.prevLabel.replace(/^Previous /, '');
  return (
    <div className="header-record-nav" role="group" aria-label={`Navigate between ${noun}s`} title={`${nav.position} of ${nav.total}`}>
      <button
        type="button"
        className="header-action-btn header-record-nav-btn"
        onClick={nav.goPrev}
        disabled={!nav.prevId}
        title={nav.prevLabel}
        aria-label={nav.prevLabel}
      >
        <Icon name="chevronLeft" size={16} />
      </button>
      <button
        type="button"
        className="header-action-btn header-record-nav-btn"
        onClick={nav.goNext}
        disabled={!nav.nextId}
        title={nav.nextLabel}
        aria-label={nav.nextLabel}
      >
        <Icon name="chevronRight" size={16} />
      </button>
    </div>
  );
};

/** The arrows for whichever record the current URL names; nothing on list pages and forms. */
const RecordNav: React.FC = () => {
  const { pathname } = useLocation();
  const record = parseEntityPath(pathname);
  if (!record) return null;
  return <RecordNavButtons kind={record.kind} currentId={record.id} />;
};

export default RecordNav;
